<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okText="this.$store.getters.language['common.okButton']"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    :ok-disabled="true"
    @setInnerFullscreen="setInnerFullscreen"
    :cancelText="language['common.closeButton']">
    <my-apply-form ref="realForm" @ok="submitCallback" :innerFullscreen="innerFullscreen"></my-apply-form>
  </j-modal>
</template>

<script>

  import MyApplyForm from './MyApplyForm'

  export default {
    name: 'MyApplyModal',
    components: {
      MyApplyForm
    },
    data() {
      return {
        title:this.$store.getters.language['common.detailsButton'],
        width: 1200,
        visible: false,
        disableSubmit: false,
        innerFullscreen:false,
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
      /*title(){
        if (this.language) {
          return '详情'
        }

      }*/
    },
    methods: {
      setInnerFullscreen(val) {
        this.innerFullscreen = val
      },
      add() {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.add();
        })
      },
      edit(record) {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.edit(record);
        })
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleOk() {
        this.$refs.realForm.submitForm();
      },
      submitCallback() {
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel() {
        this.close()
      }
    }
  }
</script>